import ModelStore from '../../shared-lib/stores/ModelStore'

export default class UserDeviceStore extends ModelStore {
  data = {
    uniqueDeviceId: '', // TODO: Generate unique device id and save to storage ?
  }
}
